module.exports = __webpack_public_path__ + "static/logo_freedom-10d1b0507c55bc6433caaf7a06368469.svg";